/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Sharedplan_RestInputs */

const en_us2_sharedplan_rest = /** @type {(inputs: Sharedplan_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`rest ${i?.seconds} s`)
};

const pt_br2_sharedplan_rest = /** @type {(inputs: Sharedplan_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`descanso ${i?.seconds} s`)
};

const pt_pt2_sharedplan_rest = /** @type {(inputs: Sharedplan_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`descanso ${i?.seconds} s`)
};

/** @type {(inputs: Sharedplan_RestInputs) => LocalizedString} */
const es_419_sharedplan_rest = en_us2_sharedplan_rest;

/** @type {(inputs: Sharedplan_RestInputs) => LocalizedString} */
const fr_fr2_sharedplan_rest = en_us2_sharedplan_rest;

/** @type {(inputs: Sharedplan_RestInputs) => LocalizedString} */
const de_de2_sharedplan_rest = en_us2_sharedplan_rest;

/** @type {(inputs: Sharedplan_RestInputs) => LocalizedString} */
const it_it2_sharedplan_rest = en_us2_sharedplan_rest;

/**
* | output |
* | --- |
* | "rest {seconds} s" |
*
* @param {Sharedplan_RestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const sharedplan_rest = /** @type {((inputs: Sharedplan_RestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharedplan_RestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_sharedplan_rest(inputs)
	if (locale === "es-419") return es_419_sharedplan_rest(inputs)
	if (locale === "pt-PT") return pt_pt2_sharedplan_rest(inputs)
	if (locale === "fr-FR") return fr_fr2_sharedplan_rest(inputs)
	if (locale === "de-DE") return de_de2_sharedplan_rest(inputs)
	if (locale === "it-IT") return it_it2_sharedplan_rest(inputs)
	return en_us2_sharedplan_rest(inputs)
});
export { sharedplan_rest as "sharedplan.rest" }